import { render, staticRenderFns } from "./AppPrint.vue?vue&type=template&id=510a5686&"
import script from "./AppPrint.vue?vue&type=script&lang=js&"
export * from "./AppPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports